import gql from 'graphql-tag';

export const FB_PIXEL_QUERY = gql`
  query FacebookPixelQuery($id: ID!) {
    facebookPixel(id: $id) {
      id
      name
      businessId
      businessName
      adAccountId
      adAccountName
    }
  }
`;
